@if (hasTiles) {
    <div class="tile-grid">
        <cdk-virtual-scroll-viewport itemSize="3" class="tile-grid__viewport">
            <ng-container *cdkVirtualFor="let tile of tiles() | groupTiles; index as i; trackBy: trackByFn">
                @if (isDividerTile(tile)) {
                    <priva-title
                        size="md"
                        iconClass="{{ tile.dividerIcon }}"
                        theme="onlightblue"
                        class="title"
                        title="{{ tile.dividerText | translate }}"
                        data-test="tile-separator"
                    />
                } @else {
                    @if (tileListUtils.isTile(tile)) {
                        <app-tile [tile]="tile" (click)="onTileClick(tile)" class="tile-grid--item" />
                    }
                }
            </ng-container>
        </cdk-virtual-scroll-viewport>
    </div>
}
